module.exports = __webpack_public_path__ + "img/collection_treasure.d4d25518.png";